/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {ContactId, ContactInput} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getEditClientContactUrl = (id: string, contactId: ContactId) => {
  return `/api/v1/sales/clients/${id}/contacts/${contactId}`;
};

/**
 * @summary Edit client contact
 */
export const editClientContact = async (
  id: string,
  contactId: ContactId,
  contactInput: ContactInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getEditClientContactUrl(id, contactId), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(contactInput),
  });
};

export const getRemoveClientContactUrl = (id: string, contactId: ContactId) => {
  return `/api/v1/sales/clients/${id}/contacts/${contactId}`;
};

/**
 * @summary Remove client contact
 */
export const removeClientContact = async (
  id: string,
  contactId: ContactId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveClientContactUrl(id, contactId), {
    ...options,
    method: "DELETE",
  });
};

export const getAddClientContactUrl = (id: string) => {
  return `/api/v1/sales/clients/${id}/contacts`;
};

/**
 * @summary Add client contact
 */
export const addClientContact = async (
  id: string,
  contactInput: ContactInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<ContactId> => {
  return customFetch<ContactId>(getAddClientContactUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(contactInput),
  });
};
